import * as React from "react";
import { Theme, ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { ThemeProvider as StyledComponentThemeProvider } from "styled-components";
import CssBaseline from "@mui/material/CssBaseline";

interface AppThemeProviderProps {
  children: React.ReactNode;
  theme: Theme;
}

function AppThemeProvider({ children, theme }: AppThemeProviderProps) {
  const appliedTheme = React.useMemo(() => theme, [theme]);

  return (
    <MuiThemeProvider theme={appliedTheme}>
      <StyledComponentThemeProvider theme={appliedTheme}>
        <CssBaseline />
        {children}
      </StyledComponentThemeProvider>
    </MuiThemeProvider>
  );
}

export { AppThemeProvider };
